import { gql } from 'graphql-request';

import { MayBe } from '../../../types';

import {
  OperationBody,
  OperationCompleteDatetime,
  OperationCreatedAt,
  OperationDate,
  OperationState,
  OperationSubject,
  OperationType,
  OperationUUID,
  OperationClientID,
  OperationTeamID,
  OperationMentionedUserID,
  OperationUserUUID,
  OperationUserNanoID,
  OperationUserFullName,
  OperationUserImageFile,
  OperationUserImageUUID,
  OperationUserClient,
  OperationUserCurrentTeamNanoID,
  OperationFileAttachmentUUID,
  OperationFileAttachmentID,
  OperationFileAttachmentFile,
  OperationFileAttachmentName,
  OperationFileAttachmentSize,
  OperationFileAttachmentExt,
  OperationFileAttachmentCreatedAt,
  OperationID,
  OperationTaskNanoID,
  OperationTaskName,
  OperationTaskProjectNanoID,
  OperationTaskProjectName,
  OperationProjectNanoID,
  OperationProjectName,
  OperationTeamNanoID,
  OperationTeamName,
  OperationTeamImageFile,
  OperationFileAttachmentOriginalFileName
} from '../operationsTypes';

export interface FetchOperationQueryResponse {
  id: OperationID;
  uuid: OperationUUID;
  body: OperationBody;
  subject: OperationSubject;
  operationType: OperationType;
  state: OperationState;
  createdAt: OperationCreatedAt;
  date: OperationDate;
  completeDatetime: OperationCompleteDatetime;
  project: MayBe<{
    nanoId: OperationProjectNanoID;
    name: OperationProjectName;
  }>;
  task: MayBe<{
    nanoId: OperationTaskNanoID;
    name: OperationTaskName;
    project: {
      nanoId: OperationTaskProjectNanoID;
      name: OperationTaskProjectName;
    };
  }>;
  fileAttachments: {
    id: OperationFileAttachmentID;
    uuid: OperationFileAttachmentUUID;
    file: OperationFileAttachmentFile;
    name: OperationFileAttachmentName;
    originalFilename: OperationFileAttachmentOriginalFileName;
    size: OperationFileAttachmentSize;
    ext: OperationFileAttachmentExt;
    createdAt: OperationFileAttachmentCreatedAt;
  }[];
  user: {
    uuid: OperationUserUUID;
    nanoId: OperationUserNanoID;
    fullName: OperationUserFullName;
    client: OperationUserClient;
    currentTeam: MayBe<{
      nanoId: OperationUserCurrentTeamNanoID;
    }>;
    image: {
      uuid: OperationUserImageUUID;
      file: OperationUserImageFile;
    };
  };
  client: {
    id: OperationClientID;
    uuid: OperationUserUUID;
    nanoId: OperationUserNanoID;
    fullName: OperationUserFullName;
    client: OperationUserClient;
    currentTeam: MayBe<{
      nanoId: OperationUserCurrentTeamNanoID;
    }>;
    image: {
      uuid: OperationUserImageUUID;
      file: OperationUserImageFile;
    };
  };
  teamId?: OperationTeamID;
  team: {
    nanoId: OperationTeamNanoID;
    name: OperationTeamName;
    image: {
      file: OperationTeamImageFile;
    };
  };
  mentionedUsers: {
    id: OperationMentionedUserID;
    uuid: OperationUserUUID;
    nanoId: OperationUserNanoID;
    fullName: OperationUserFullName;
    client: OperationUserClient;
    currentTeam: MayBe<{
      nanoId: OperationUserCurrentTeamNanoID;
    }>;
    image: {
      uuid: OperationUserImageUUID;
      file: OperationUserImageFile;
    };
  }[];
}

export const FETCH_OPERATION_QUERY = gql`
  query Operation($uuid: ID!) {
    operation(uuid: $uuid) {
      id
      uuid
      body
      subject
      operationType
      state
      completeDatetime
      createdAt
      date
      project {
        nanoId
        name
      }
      task {
        nanoId
        name
        project {
          nanoId
          name
        }
      }
      fileAttachments {
        id
        uuid
        file
        name
        originalFilename
        size
        ext
        createdAt
      }
      user {
        uuid
        nanoId
        fullName
        client
        currentTeam {
          nanoId
        }
        image {
          uuid
          file
        }
      }
      client {
        id
        uuid
        nanoId
        fullName
        client
        currentTeam {
          nanoId
        }
        image {
          uuid
          file
        }
      }
      teamId
      team {
        nanoId
        name
        image {
          file
        }
      }
      mentionedUsers {
        id
        uuid
        nanoId
        fullName
        client
        currentTeam {
          nanoId
        }
        image {
          uuid
          file
        }
      }
    }
  }
`;
